<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <!-- <transition-group name="breadcrumb"> -->
    <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">
      <a @click.prevent="handleLink(item)">{{ item.text }}</a>
    </el-breadcrumb-item>
    <!-- </transition-group> -->
  </el-breadcrumb>
</template>

<script>
  import { compile } from 'path-to-regexp'
  export default {
    data() {
      return {
        levelList: null,
        breadcrumbList: []
      }
    },
    watch: {
      $route() {
        this.getBreadcrumb()
      }
    },
    created() {
      this.getBreadcrumb()
    },
    methods: {
      getBreadcrumb() {
        this.breadcrumbList = this.$route.meta.breadcrumb
      },
      handleLink(item) {
        if (item.path) {
          this.$router.push(this.pathCompile(item.path))
        } else {
          this.$router.push(item.to)
        }
      },
      pathCompile(path) {
        const { params } = this.$route
        const toPath = compile(path)
        return toPath(params)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 8px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>
